import { useTranslation } from "react-i18next";
import { AppSeparator } from "@/components/ui";

export function AuthDivider(): React.ReactElement {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-4 py-2">
      <AppSeparator className="flex-1" />
      <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-foreground-muted">
        {t("auth.oauth.divider")}
      </span>
      <AppSeparator className="flex-1" />
    </div>
  );
}
